import { jwtDecode } from "jwt-decode";

const ROLE_TO_DASHBOARD = {
    ADMIN: "/dashboard",
    PROJECT_MANAGER: "/projectmanagerdashboard",
    PROJECT_COORDINATOR: "/projectcoordinatordashboard",
    CENTER_MANAGER: "/centermanagerdashboard",
    FUNDER: "/funderdashboard",
    PM: "/projectmanagerdashboard",
    PC: "/projectcoordinatordashboard",
    CM: "/centermanagerdashboard"
};

export const normalizeRole = (role) => {
    if (!role) return "";
    return String(role).replace(/^ROLE_/, "").trim().toUpperCase();
};

export const getDashboardPathForRole = (role) => {
    const normalizedRole = normalizeRole(role);
    return ROLE_TO_DASHBOARD[normalizedRole] || "/dashboard";
};

export const getRoleFromToken = (token) => {
    if (!token) return "";

    const decoded = jwtDecode(token);
    return decoded?.role || decoded?.authorities?.[0] || "";
};

export const getDashboardPathFromToken = (token) => {
    return getDashboardPathForRole(getRoleFromToken(token));
};
